import * as React from "react";

import { cn } from "./utils";
import { normalizePastedText } from "./normalizePastedText";

function Textarea({ className, onPaste, ...props }: React.ComponentProps<"textarea">) {
  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    const text = e.clipboardData.getData("text/plain");
    const normalized = normalizePastedText(text, { keepNewlines: true });
    if (normalized !== null) {
      e.preventDefault();
      document.execCommand("insertText", false, normalized);
    }
    onPaste?.(e);
  };

  return (
    <textarea
      data-slot="textarea"
      onPaste={handlePaste}
      className={cn(
        "resize-none border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-input-background px-3 py-2 text-base transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
